<div box direction="row" justify="between" align="center" fill="horizontal">
  <div box direction="row" align="center">
    <!-- Nav Toggle -->
    @if (layoutState.isIconView) {
      <button mat-icon-button
        class="nav__toggle-icon"
        (click)="toggleSidebar()"
        [disableRipple]="true">
        <mat-icon class="matomo_header"
        svgIcon="menu"></mat-icon>
      </button>
    }

    <!-- Search -->
    <global-search [userId]="user.id!"></global-search>

    <!-- Banner -->
    @if (isLowerEnvironment) {
      <div class="env-notification">
        <mat-icon svgIcon="warning"
        color="primary"> </mat-icon>
        <span>{{ 'sharedNav.appHeader.envNoticePrefix' | transloco }} <a href="https://ideal.io/app/home">{{ 'sharedNav.appHeader.envNoticeLinkText' | transloco }}</a> {{ 'sharedNav.appHeader.envNoticeSuffix' | transloco }}</span>
      </div>
    }

    <!-- Add new -->
    <action-menu-button
      [label]="'sharedNav.appHeader.addNew' | transloco"
      [showChevron]="true"
      trackingClass="matomo_header"
      [actionMenuButtonItems]="actionMenuButtonItems">
    </action-menu-button>
  </div>

  <div box direction="row" gap="xsmall" align="center">
    @if (canViewNotificationCenter) {
      <button class="notification-bell-icon" mat-icon-button (click)="toggleNotificationsSidebar()">
        <mat-icon svgIcon="{{(notificationService.isEnableNotificationBellIcon$ | async) ? 'Notification_ON' : 'Notification' }}"
        color="primary"> </mat-icon>
      </button>
    }

    <!-- Account Btn -->
    <button mat-button
      class="account__btn"
      [matMenuTriggerFor]="account">
      <div box
        align="center"
        direction="row"
        [wrap]="false">
        <div mat-line
          class="matomo_header account__btn-text">
          {{ getActiveTeamName() }}
        </div>
        <div class="avatar">
          {{ user.firstName[0] + user.lastName[0] }}
        </div>
      </div>
    </button>
  </div>
</div>


<!-- Account Menu -->
<mat-menu #account="matMenu"
  class="no-padding ideal-light-theme">
  <!-- Avatar & Names -->
  <div box
    direction="column"
    justify="center"
    align="center"
    class="account__avatar"
    (click)="$event.stopPropagation()">
    <div class="avatar avatar_lg">
      {{ user.firstName[0] + user.lastName[0] }}
    </div>
    <span class="matomo_header account__name"
      title="{{ user.name }}">
      {{ user.name }}
    </span>
    <span class="matomo_header account__email"
      title="{{ user.email }}">
      {{ user.email }}
    </span>
  </div>

  <!-- Select Version & Team -->
  @if (!defaultsPanelActive) {
    <div box
      (click)="$event.stopPropagation()"
      class="account__preferences">
      <!-- Version -->
      @if (showVersionField) {
        <div class="w-100">
          <label class="field-label"> {{ 'sharedNav.appHeader.version' | transloco }} </label>
          <mat-form-field class="account__select"
            (click)="$event.stopPropagation()"
            appearance="outline">
            <mat-select [(value)]="selectedVersionId"
              [disableOptionCentering]="true">
              @for (version of versions; track version) {
                <mat-option
                  [value]="version.id"
                  (click)="setVersion(version.id)"
                  class="select-option">
                  <span class="matomo_header">{{ version.name }}</span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      <!-- Team -->
      <div class="w-100">
        <label class="field-label"> {{ 'sharedNav.appHeader.team' | transloco }} </label>
        <mat-form-field class="account__select"
          (click)="$event.stopPropagation()"
          appearance="outline">
          <mat-select [(value)]="user.activeTeamId"
            [disableOptionCentering]="true">
            @for (team of activeTeams; track team) {
              <mat-option
                [value]="team.id"
                (click)="setTeam(team.id)"
                class="select-option">
                <span class="matomo_header"> {{ team.name }}</span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <!-- View Defaults -->
      @if (showVersionField && !isDebtUser) {
        <div box
          (click)="$event.stopPropagation()">
          <a class="matomo_header account__defaults-btn"
            (click)="$event.stopPropagation(); toggleDefaultsPanel(true)">
            {{ 'sharedNav.appHeader.changeDefaultOptions' | transloco }}
          </a>
        </div>
      }
      @if (isDebtUser) {
        <div box
          (click)="$event.stopPropagation()">
          <a class="matomo_header account__defaults-btn"
            (click)="$event.stopPropagation(); account.close.emit(); openPreferences()">
            {{ 'sharedNav.appHeader.managePreferences' | transloco }}
          </a>
        </div>
      }
    </div>
  }

  <mat-divider />

  <!-- Logout -->
  @if (!defaultsPanelActive) {
    <button mat-menu-item
      (click)="onLogout.emit()"
      class="account__logout-btn"
      >
      <mat-icon svgIcon="log-out"
      color="primary"> </mat-icon>
      <span class="matomo_header"> {{ 'shared.common.signOut' | transloco }} </span>
    </button>
  }

  <!-- Default Options Panel -->
  @if (defaultsPanelActive) {
    <div box
      class="account__defaults-container"
      (click)="$event.stopPropagation()">
      <!-- Title & back btn -->
      <div box
        (click)="$event.stopPropagation()"
        fill="horizontal"
        direction="row"
        [wrap]="false"
        align="center"
        class="account__defaults-title">
        <button mat-icon-button
          class="account__defaults-btn-back"
          (click)="$event.stopPropagation();toggleDefaultsPanel(false)">
          <mat-icon svgIcon="chevron-right"
            style="transform: scaleX(-1)">
          </mat-icon>
        </button>
        <span class="matomo_header"> {{ 'sharedNav.appHeader.defaultPreferences' | transloco }} </span>
      </div>
      <!-- Default Version -->
      @if (showVersionField) {
        <div>
          <label class="field-label"> {{ 'sharedNav.appHeader.defaultVersion' | transloco }} </label>
          <mat-form-field class="account__select"
            (click)="$event.stopPropagation()"
            appearance="outline">
            <mat-select [(value)]="selectedDefaultVersionId"
              [disableOptionCentering]="true"
              (selectionChange)="onVersionChange()">
              @for (version of versions; track version) {
                <mat-option
                  [value]="version.id"
                  class="select-option">
                  <span class="matomo_header">{{ version.name }}</span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      <!-- Default Team -->
      <label class="field-label"> {{ 'sharedNav.appHeader.defaultTeam' | transloco }} </label>
      @if (defaultTeams.length === 0) {
        <div box
          class="select__no-data">
          <span>{{ 'sharedNav.appHeader.noTeamsAvailable' | transloco }}</span>
        </div>
      }
      @if (defaultTeams.length > 0) {
        <mat-form-field class="account__select"
          (click)="$event.stopPropagation()"
          appearance="outline"
          >
          <mat-select [(value)]="selectedDefaultTeamId"
            [disableOptionCentering]="true">
            @for (team of defaultTeams; track team) {
              <mat-option
                [value]="team.id"
                class="select-option">
                <span class="matomo_header">{{ team.name }}</span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <!-- Save Defaults -->
      <div box
        align="center"
        fill="horizontal">
        <button mat-flat-button
          color="primary"
          (click)="setVersionAndTeam()">
          <span class="matomo_header"> {{ 'sharedNav.appHeader.savePreferences' | transloco }} </span>
        </button>
      </div>
    </div>
  }
</mat-menu>

@if (canViewNotificationCenter) {
  <app-notifications
    [isOpen]="open()"
    (isOpenChange)="isOpenChange($event)"
    />
}

@if (showAddContactPopup) {
  <add-contact
    [open]="showAddContactPopup"
    [openInDialog]="showAddContactPopup"
    (closePopup)="showAddContactPopup=false;" />
}

@if (showAddActivityModal) {
  <add-new-activity [open]="showAddActivityModal" [entityType]="entityType.Deal" [entityId]="0" [platform]="platform"
    [noteType]="noteType" [noteLinks]="linkDeals" [permissionEntities]="permissions" [title]="modalTitle"
    (onDialogClose)="showAddActivityModal = false" />
}
